export enum REFERENCIALS_URL {
  INCOTERMS = '/incoterm-referential',
  COUNTRY_CODE = '/country-code-referential',
  COMPANY_TYPE = '/company-type-referential',
  FOLDERS_STATUS = '/folder-status-referential',
  PAYMENT_METHOD = '/payment-method-referential',
  FOLDER_TYPOLOGY = '/folder-typology-referential',
  VEHICLE_TYPE_REFERENTIAL = '/vehicle-type-referential',
  CROSSING_HOUR_RANGE = '/crossing-hour-range-referential',
  COUNTRIES_OF_DISPATCH = '/country-of-dispatch-referential',
  CROSSING_DOCUMENTS_TYPE = '/crossing-document-type-referential',
  COUNTRIES_OF_DESTINATION = '/country-of-destination-referential',
  CROSSING_DOCUMENTS_STATUS = '/crossing-document-status-referential',
  CUSTOMS_DOCUMENTS_STATUS = '/customs-document-statuses-referential',
  SHERPASS_CUSTOMS_DOCUMENTS_TYPE = '/sherpass-customs-document-type-referential',
  APPLICANT_CUSTOMS_DOCUMENTS_TYPE = '/applicant-customs-document-type-referential',
  SHERPASS_CUSTOMS_DOCUMENTS_STATUS = '/sherpass-customs-document-status-referential',
  CARRIER_BORDER_CROSSING_ASSOCIATION_TYPOLOGY = '/carrier-border-crossing-service-association-referential',
  APPLICANT_TRANSMITTED_DOCUMENT_ANOMALY_REASON = '/applicant-transmitted-document-anomaly-reason-referential',
  APPLICANT_TRANSMITTED_CUSTOMS_DOCUMENTS_STATUS = '/applicant-transmitted-customs-document-status-referential',
}
